"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapperError = exports.StyledTextField = exports.StyledPopOver = exports.StyledInputLabel = exports.StyledInfoMessageTxt = exports.StyledInfoMessage = exports.StyledInfoIcon = exports.StyledIconButton = exports.StyledFormControl = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));

var _ErrorHelperText = _interopRequireDefault(require("../ErrorHelperText/ErrorHelperText"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var StyledFormControl = (0, _styledComponents.default)(_material.FormControl)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"])));
/* istanbul ignore next */

exports.StyledFormControl = StyledFormControl;
var StyledInputLabel = (0, _styledComponents.default)(_material.InputLabel)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 22px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  position: unset;\n  pointer-events: unset;\n  text-transform: uppercase;\n\n  .MuiInputLabel-asterisk {\n    color: ", ";\n    font-size: 22px;\n  }\n\n  .MuiIconButton-root {\n    bottom: 5px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary.main;
});
/* istanbul ignore next */

exports.StyledInputLabel = StyledInputLabel;
var StyledTextField = (0, _styledComponents.default)(_material.TextField)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n\n  .MuiInputBase-root {\n    border-radius: 5px;\n    margin-bottom: 5px;\n    min-height: 52px;\n    &:hover {\n      border-color: ", ";\n    }\n  }\n\n  .Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: 1px solid ", ";\n  }\n\n  .Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: 1px solid ", ";\n  }\n\n  .Mui-disabled {\n    border-radius: 5px;\n    cursor: not-allowed;\n    background-color: ", ";\n\n    .MuiOutlinedInput-notchedOutline {\n      border-style: none;\n      border-color: unset;\n    }\n  }\n\n  .Mui-error .MuiOutlinedInput-input {\n    color: ", ";\n  }\n\n  .Mui-disabled.Mui-error {\n    border: 1px solid ", ";\n  }\n\n  .MuiOutlinedInput-input {\n    color: ", ";\n    font-size: 16px;\n    font-weight: 500;\n    height: 100%;\n  }\n\n  .MuiFormHelperText-root {\n    font-size: 14px;\n    margin: 3px 0 0 0;\n    color: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.secondary.main;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.secondary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.main;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.primary.main;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.secondary.main;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.color.grey;
});
/* istanbul ignore next */

exports.StyledTextField = StyledTextField;
var StyledWrapperError = (0, _styledComponents.default)('div')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n  p {\n    color: ", ";\n    font-size: 14px;\n    font-style: italic;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.error.main;
});
/* istanbul ignore next */

exports.StyledWrapperError = StyledWrapperError;
var StyledInfoMessageTxt = (0, _styledComponents.default)(_ErrorHelperText.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  opacity: 1;\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.secondary.main;
});
exports.StyledInfoMessageTxt = StyledInfoMessageTxt;
var StyledIconButton = (0, _styledComponents.default)(_material.IconButton)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 3px;\n  font-size: 1.2rem;\n"])));
exports.StyledIconButton = StyledIconButton;
var StyledInfoIcon = (0, _styledComponents.default)(_InfoOutlined.default)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 22px;\n  color: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.secondary.main;
});
exports.StyledInfoIcon = StyledInfoIcon;
var StyledPopOver = (0, _styledComponents.default)(_material.Popover)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  pointer-events: none;\n  .MuiPopover-paper{\n    max-width: 500px;\n  }\n"])));
/* istanbul ignore next */

exports.StyledPopOver = StyledPopOver;
var StyledInfoMessage = (0, _styledComponents.default)(_material.Typography)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  background-color: ", ";\n  padding: 5px;\n  font-size: 12px;\n  line-height: 14px;\n  padding: 8px;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.secondary.main;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.color.blueLight;
});
exports.StyledInfoMessage = StyledInfoMessage;